export default __webpack_public_path__ + "static/media/04.6287644d.png";